import { Typography } from "antd";
import styles from "./order.module.scss";
import { TotalItemsIcon } from "../../assets/icons/TotalItemsIcon";
import { TotalPiecesIcon } from "../../assets/icons/TotalPiecesIcon";
import { TotalErrorsIcon } from "../../assets/icons/TotalErrorsIcon";

const { Text } = Typography;

const OrderTotals: React.FC<any> = ({ headerText, icon, total }) => {
  return (
    <div className={styles.cardHeader}>
      <Text type="secondary" strong className={styles.cardText}>
        <span className={styles.cardLabel}>{headerText}</span>
      </Text>
      <div className={styles.cardBody}>
        <div className={styles.cardIconWrap}>
          {icon === 1 ? (
            <TotalItemsIcon />
          ) : icon === 2 ? (
            <TotalErrorsIcon />
          ) : (
            <TotalPiecesIcon />
          )}
        </div>
        <Text className={styles.cardVal}>
          {!total || total === "0" ? "–" : total}
        </Text>
      </div>
    </div>
  );
};

export default OrderTotals;
